/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import {
  Grid,
  FormControl,
  TextField,
  Button,
  Select,
  MenuItem,
  Box,
  InputLabel,
  LinearProgress,
  CircularProgress,
} from '@material-ui/core'
import '../../../Elegibilidad/Style/crearFormularioElegibilidad.scss'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import NumberFormat from 'react-number-format'
import Modal from '@mui/material/Modal'
import swal from 'sweetalert'
import Swal from 'sweetalert2'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import ReactTooltip from 'react-tooltip'
import SelectReact from 'react-select'
import Stack from '@mui/material/Stack'
import ExitIcon from '@material-ui/icons/ExitToApp'
import SaveIcon from '@material-ui/icons/Save'
import Moment from 'moment'
import { useHistory } from 'react-router-dom'
import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'
import { useAuthentication } from '../../../../../context/authenticationContext'
import { getMIPYMESList } from '../../../../../services/IFI/get'

import {
  getCurrency,
  getCurrencyByCountry,
  getProjectByMiPYME,
  getProjectForm,
  insertDefaultValues,
} from '../../../../../services/Elegibilidad/get'
import { saveDrafElegibilityForm } from '../../../../../services/Elegibilidad/create'
import { useEligibility } from '../../../../../context/EligibilityContext'
import ROUTES from '../../../../../routers/routes'
import { validateEditForm } from '../../../../../services/Forms/create'
import { LoadingButton } from '@mui/lab'

const ElegibilidadEdit1 = (props) => {
  const [state, dispatch] = useEligibility()
  const { goToStep } = props

  const {
    setIdElegibilityForm,
    editFormElegibility,
    setEditFormElegibility,
    setPreEligibilityForm2,
  } = useFormElegibilidad()

  const { IdIFIToken, userIDB2C } = useAuthentication()

  const history = useHistory()

  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(false)
  const [secLoading, setSecLoading] = useState(true)
  const [IFIsMiPymeList, setIFIsMiPymeList] = useState([])
  const [showExchange, setShowExchange] = useState(false)
  const [loadingExchange, setLoadingExchange] = useState(false)
  const [options, setOptions] = useState([])
  const [selectedPYME, setSelectedPYME] = useState('')
  const [dataProject, setDataProject] = useState([])
  const [infoProject, setInfoProject] = useState({ RequiredAmount: '' })
  const [currencyType, setCurrencyType] = useState([])
  const [currencyCode, setCurrencyCode] = useState('')
  const [open, setOpen] = useState(false)
  const [pymeError, setPymeError] = useState('')
  const [loadingSave, setLoadingSave] = useState(false)

  const min = '2021-06-30'
  const max = '2200-01-01'

  const GeneralDataSchema = Yup.object().shape({
    IdCurrencyUser: Yup.number()
      .required('Este campo es obligatorio')
      .moreThan(0, 'Este campo es obligatorio'),
    TotalSubProjectBudget: Yup.number()
      .required('Este campo es obligatorio')
      .when('IdCurrencyUser', {
        is: (IdCurrencyUser) =>
          Number(IdCurrencyUser) !== 0 && Number(IdCurrencyUser) === 3,
        then: Yup.number().test(
          'superior',
          'El monto no debe ser menor al monto total del préstamo solicitado.',
          function (f) {
            const ref = infoProject.RequiredAmount
            return f >= this.resolve(ref)
          },
        ),
      }),
    TotalSubProjectBudgetDollar: Yup.number()
      .required('Este campo es obligatorio')
      .when('IdCurrencyUser', {
        is: (IdCurrencyUser) =>
          Number(IdCurrencyUser) !== 0 && Number(IdCurrencyUser) !== 3,
        then: Yup.number().test(
          'superior',
          'El monto no debe ser menor al monto total del préstamo solicitado.',
          function (f) {
            const ref = infoProject.RequiredAmount
            return f >= this.resolve(ref)
          },
        ),
      }),
    PresentationDate: Yup.date().required(),
    ImplementationDateStart: Yup.date()
      .required('Este campo es obligatorio')
      .min(new Date(min), `La fecha de inicio no debe ser menor a ${min}`)
      .max(new Date(max), `La fecha de inicio no debe ser mayor al 2200`),
    ImplementationDateEnd: Yup.date()
      .max(new Date(max), `La fecha fin no debe ser mayor al 2200`)
      .required('Este campo es obligatorio')
      .when(
        'ImplementationDateStart',
        (ImplementationDateStart, schema) =>
          ImplementationDateStart &&
          schema.min(
            ImplementationDateStart,
            'La fecha de finalizacion no puede ser menor a la fecha de inicio.',
          ),
      )
      .when(
        'PresentationDate',
        (PresentationDate, schema) =>
          PresentationDate &&
          schema.min(
            PresentationDate,
            'La fecha de finalizacion no puede ser menor a la fecha de presentación.',
          ),
      ),
    IdIFI: Yup.string().required('Este campo es obligatorio'),
  })

  const valueDate = {
    someDate: new Date().toISOString().substring(0, 10),
  }

  const formik = useFormik({
    // enableReinitialize: true,
    // validateOnChange: false,
    initialValues: {
      IdUserAzureB2C: userIDB2C,
      IdElegibilityAnswer: editFormElegibility.IdElegibilityAnswer || -1,
      MiPymeName: editFormElegibility.MiPymeName
        ? editFormElegibility.MiPymeName
        : '',
      IdRiskCategory: 'C',
      ImplementationDateStart: editFormElegibility.ImplementationDateStart
        ? Moment(editFormElegibility.ImplementationDateStart)
            .format('YYYY-MM-DD')
            .toString()
        : '',
      ImplementationDateEnd: editFormElegibility.ImplementationDateEnd
        ? Moment(editFormElegibility.ImplementationDateEnd)
            .format('YYYY-MM-DD')
            .toString()
        : '',
      PresentationDate: valueDate.someDate,
      IdCountryCredit: editFormElegibility.IdCountryCredit
        ? editFormElegibility.IdCountryCredit
        : '',
      IdIFI: editFormElegibility.IdIFI ? editFormElegibility.IdIFI : '',
      IdCurrencyUser: editFormElegibility.IdCurrencyUser
        ? editFormElegibility.IdCurrencyUser
        : '',
      TotalSubProjectBudget: editFormElegibility.TotalSubProjectBudget
        ? editFormElegibility.TotalSubProjectBudget
        : 0,
      TotalSubProjectBudgetDollar:
        editFormElegibility.TotalSubProjectBudgetDollar
          ? editFormElegibility.TotalSubProjectBudgetDollar
          : 0,
      IdProject: editFormElegibility.IdProject
        ? editFormElegibility.IdProject
        : '',
      CompanyName: editFormElegibility.CompanyName
        ? editFormElegibility.CompanyName
        : '',
      CompanyTypeId: editFormElegibility.CompanyTypeId
        ? editFormElegibility.CompanyTypeId
        : '',
      CompanyId: editFormElegibility.CompanyId
        ? editFormElegibility.CompanyId
        : '',
      ProjectName: editFormElegibility.SubprojectName
        ? editFormElegibility.SubprojectName
        : '',

      RequiredAmount: editFormElegibility.RequiredAmount
        ? editFormElegibility.RequiredAmount
        : '',
      Sector: editFormElegibility.Sector ? editFormElegibility.Sector : '',
      MiPymeType: editFormElegibility.MiPymeType
        ? editFormElegibility.MiPymeType
        : '',

      MiPymeCountry: '',
      Draft: true,
      IdFormAction: 16,
      BusinessName: '',
      IdMipyme: '',
      UserCurrencyToDollarExchangeRate: 1,
      ENumber: editFormElegibility.ENumber ? editFormElegibility.ENumber : '',
    },
    validationSchema: GeneralDataSchema,
    onSubmit: (values) => {
      saveForm(values, false)
    },
  })

  const saveForm = async (values, borrador, exit) => {
    setLoadingSave(true)
    if (values.IdProject !== null && values.IdMipyme !== null) {
      try {
        const object = {
          ...values,
          ImplementationDateEnd:
            values.ImplementationDateEnd === ''
              ? null
              : values.ImplementationDateEnd,
          ImplementationDateStart:
            values.ImplementationDateStart === ''
              ? null
              : values.ImplementationDateStart,
          IdCurrencyUser:
            values.IdCurrencyUser === 0 ? null : values.IdCurrencyUser,
          IdFormAction: 24,
        }
        const response = await saveDrafElegibilityForm({
          ...editFormElegibility,
          ...object,
        })
        if (response.Code === 200) {
          saveValuesToContext(values)
          setEditFormElegibility((prev) => {
            return {
              ...prev,
              IdElegibilityAnswer: response.Data.IdElegibilityAnswer,
            }
          })
          setIdElegibilityForm(response.Data.IdElegibilityAnswer)
          if (response.Data.IdElegibilityAnswer !== 0) {
            const responseDefault = await insertDefaultValues(
              response.Data.IdElegibilityAnswer,
            )
            // TODO: Revisar que pasa si el servicio falla
            if (responseDefault.Code !== 200) {
              console.log('Ocurrio un error', responseDefault)
              // throw Error()
            }
          }

          if (borrador) {
            setLoadingSave(false)
            swal({
              title: 'Formulario Guardado',
              icon: 'success',
              button: 'Entendido',
            })
            if (exit) {
              history.push(ROUTES.IFIBORRADOR.pathname)
            }
          } else {
            setLoadingSave(false)
            next()
          }
        } else {
          throw Error(response.Message)
          // setLoading(false)
        }
      } catch (error) {
        setLoadingSave(false)
        console.log(error.message)
      }
    } else {
      alertValidationFields()
    }
  }

  const saveValuesToContext = (values) => {
    setEditFormElegibility((previous) => {
      const valores = {
        Draft: values.Draft,
        IdElegibilityAnswer: values.IdElegibilityAnswer,
        IdMipyme: values.IdMipyme,
        MiPymeName: values.MiPymeName,
        IdRiskCategory: values.IdRiskCategory,
        ImplementationDateStart: values.ImplementationDateStart,
        ImplementationDateEnd: values.ImplementationDateEnd,
        PresentationDate: values.PresentationDate,
        IdCountryCredit: values.IdCountryCredit,
        IdIFI: values.IdIFI,
        IdCurrencyUser: values.IdCurrencyUser,
        TotalSubProjectBudget: values.TotalSubProjectBudget,
        TotalSubProjectBudgetDollar: values.TotalSubProjectBudgetDollar,
        IdProject: values.IdProject,
        ProjectName: values.ProjectName,
        IdLegalRepresentative: values.IdLegalRepresentative,
        LegalRepresentativeName: values.LegalRepresentativeName,
        MiPymeCountry: values.MiPymeCountry,
        RequiredAmount: values.RequiredAmount,
        UserCurrencyToDollarExchangeRate:
          values.UserCurrencyToDollarExchangeRate,
        idElegibilityForm: values.idElegibilityForm,
        IdFormAction: values.IdFormAction,
        Sector: values.Sector,
        MiPymeType: values.MiPymeType,
        TotalEmployees: values.TotalEmployees,
        IdUserAzureB2C: userIDB2C,
        ENumber: values.Enumber,
        RequiredAmountSourceCurrency: values.RequiredAmountSourceCurrency,
      }
      return {
        ...previous,
        ...valores,
      }
    })
  }

  const next = () => {
    dispatch({ type: 'SET_STATE', payload: 2 })
    goToStep(2)
  }

  const getIFIMiPymes = async () => {
    try {
      const response = await getMIPYMESList(IdIFIToken)
      if (response.Success) {
        setIFIsMiPymeList(response.Data)
        fillModalOptions(response.Data) // llena el desplegable del modal para seleccionar MiPymes
      } else {
        console.log('Error obteniendo miPymes de IFI:')
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  // Función para obtener la moneda por pais
  const getListCurrencyByCountry = async (InfoCountry) => {
    try {
      const response = await getCurrencyByCountry(InfoCountry)
      if (response.Success) {
        setCurrencyType(response.Data)
      } else {
        throw Error(response.Message)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  const handleClose = () => {
    setOpen(false)
    setSelectedPYME('')
  }

  const handlePYME = async () => {
    if (selectedPYME && selectedPYME.value !== 0) {
      try {
        const response = await getProjectByMiPYME(selectedPYME.value)
        if (response.Success) {
          setDataProject(response.Data)
        } else {
          throw Error('Error obteniendo Proyectos: ' + response.Message)
        }
        handleClose()
      } catch (error) {
        console.log(error.message)
      }
    } else {
      setPymeError('Campo Obligatorio')
      setSelectedPYME('')
    }
  }

  const handlePYME2 = async (miPymeName) => {
    try {
      const data = IFIsMiPymeList.find((e) => e.BusinessName === miPymeName)
      formik.setValues({
        ...formik.values,
        MiPymeName: data.BusinessName,
        IdMipyme: data.IdMiPyme,
      })

      const response = await getProjectByMiPYME(data.IdMiPyme)
      if (response.Success) {
        setDataProject(response.Data)
      } else {
        throw Error('Error obteniendo Proyectos: ' + response.Message)
      }
      handleClose()
    } catch (error) {
      console.log(error.message)
    }
  }

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const SelectCurrencyUser = (e) => {
    switch (e.target.value) {
      case 1:
        setCurrencyCode('HNL')
        break
      case 2:
        setCurrencyCode('NIC')
        break
      case 3:
        setCurrencyCode('DOM')
        break
      case 4:
        setCurrencyCode('CRC')
        break
      case 5:
        setCurrencyCode('GTQ')
        break
      case 6:
        setCurrencyCode('DOP')
        break
      default:
        setCurrencyCode('')
    }
    if (e.target.value !== 3) {
      setShowExchange(true)
    } else {
      setShowExchange(false)
      formik.setFieldValue('TotalSubProjectBudgetDollar', 0)
    }

    formik.setValues({
      ...formik.values,
      IdCurrencyUser: e.target.value,
    })
  }

  const SelectCurrencyUser2 = (value) => {
    switch (value) {
      case 1:
        setCurrencyCode('HNL')
        break
      case 2:
        setCurrencyCode('NIC')
        break
      case 3:
        setCurrencyCode('DOM')
        break
      case 4:
        setCurrencyCode('CRC')
        break
      case 5:
        setCurrencyCode('GTQ')
        break
      case 6:
        setCurrencyCode('DOP')
        break
      default:
        setCurrencyCode('')
    }
    if (value !== 3) {
      setShowExchange(true)
    } else {
      setShowExchange(false)
      formik.setFieldValue('TotalSubProjectBudgetDollar', 0)
    }

    formik.setValues({
      ...formik.values,
      IdCurrencyUser: value,
    })
  }

  // Funcion para el cambio de la moneda
  const handleCurrency = async (value) => {
    setLoadingSave(true)
    const dataCurrency = {
      SourceCurrencyCode: currencyCode,
      TargetCurrencyCode: 'USD',
      OriginalAmount: value,
    }

    const dataCurrency2 = {
      SourceCurrencyCode: 'USD',
      TargetCurrencyCode: currencyCode,
      OriginalAmount: 1,
    }

    const newValue = formik.values.TotalSubProjectBudget
    const newValueInt = newValue.toString().replaceAll(',', '')
    // si selecciona el dolar
    if (formik.values.IdCurrencyUser === 3) {
      setLoadingSave(false)
      await formik.setFieldValue(
        'TotalSubProjectBudgetDollar',
        Number(newValueInt),
      )
    } else {
      try {
        setLoadingExchange(true)
        const response = await getCurrency(dataCurrency)
        const response2 = await getCurrency(dataCurrency2)

        if (response2.error === null) {
          const Exchange =
            response2.result
              .retrieveGlobalStandardSpecificationCurrencyExchangeResponse
              .currencyExchange.resultingAmount

          formik.setFieldValue(
            'UserCurrencyToDollarExchangeRate',
            Number(Exchange),
          )
        }
        setLoadingExchange(false)
        formik.setFieldValue(
          'TotalSubProjectBudgetDollar',
          response.result
            .retrieveGlobalStandardSpecificationCurrencyExchangeResponse
            .currencyExchange.resultingAmount,
          false,
        )
        setLoadingSave(false)
      } catch (error) {
        console.log(error)
        swal({
          icon: 'error',
          title: 'Fallo en servicio',
          text: 'No se pudo convertir a USD!',
        })
      }
    }
  }

  useEffect(() => {
    getIFIMiPymes() // Obtiene las MiPyme de la IFI
    if (formik.values.IdCountryCredit) {
      selectProject2(formik.values.IdProject)
      // getListCurrencyByCountry(formik.values.IdCountryCredit) // Obtiene las monedas disponibles para este pais
    }
    if (
      formik.values.IdCurrencyUser !== null &&
      formik.values.IdCurrencyUser !== '' &&
      formik.values.IdCurrencyUser !== 3
    ) {
      setLoadingExchange(true)
      SelectCurrencyUser2(formik.values.IdCurrencyUser)
    }
  }, [])

  const handleCurrencyLocal = async (value) => {
    const dataCurrency = {
      SourceCurrencyCode: 'USD',
      TargetCurrencyCode: currencyCode,
      OriginalAmount: value,
    }

    try {
      const response = await getCurrency(dataCurrency)
      formik.setFieldValue(
        'RequiredAmountSourceCurrency',
        response.result
          .retrieveGlobalStandardSpecificationCurrencyExchangeResponse
          .currencyExchange.resultingAmount,
      )
    } catch (error) {
      console.log(error)
      // swal({
      //   icon: 'error',
      //   title: 'Fallo en servicio',
      //   text: 'No se pudo convertir a USD!',
      // })
    }
  }

  useEffect(() => {
    if (
      currencyCode !== '' &&
      infoProject !== [] &&
      // infoProject?.IdCurrency === 3 &&
      formik.values.IdCurrencyUser !== 3
    )
      if (infoProject?.IdCurrency === 3) {
        handleCurrencyLocal(infoProject.RequiredAmount)
      } else {
        formik.setFieldValue(
          'RequiredAmountSourceCurrency',
          infoProject.RequiredAmountSourceCurrency,
        )
      }
    handleCurrencyLocal(infoProject.RequiredAmount)
  }, [currencyCode, infoProject])

  useEffect(() => {
    if (formik.values.IdCurrencyUser !== 0 && currencyCode !== '') {
      handleCurrency(formik.values.TotalSubProjectBudget)
    }
  }, [currencyCode])
  useEffect(() => {
    if (formik.values.IdCurrencyUser !== 0 && currencyCode !== '') {
      formik.setFieldValue('TotalSubProjectBudgetDollar', 0, false)
      handleCurrency(formik.values.TotalSubProjectBudget)
    }
  }, [formik.values.IdCurrencyUser, formik.values.TotalSubProjectBudget])

  useEffect(() => {
    if (IFIsMiPymeList.length > 0) {
      handlePYME2(formik.values.MiPymeName)
      selectProject2(formik.values.IdProject)
    }
  }, [IFIsMiPymeList.length])

  useEffect(() => {
    if (infoProject && infoProject.RequiredAmount !== '') {
      setSecLoading(false)
    }
  }, [infoProject.RequiredAmount])

  const cancelForm = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Se perderán los datos no guardados',
      icon: 'warning',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      confirmButtonColor: '#3085d6',
      denyButtonText: `No guardar`,
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await validateEditForm(
          userIDB2C,
          2,
          editFormElegibility.IdElegibilityAnswer,
        )
        if (response.Success) {
          const exit = true
          saveForm(formik.values, true, exit)
        }
      } else if (result.isDenied) {
        const response = await validateEditForm(
          userIDB2C,
          2,
          editFormElegibility.IdElegibilityAnswer,
        )
        if (response.Success) history.push(ROUTES.IFIBORRADOR.pathname)
      }
    })
  }

  const selectProject = async (e) => {
    const idProject = e.target.value
    try {
      const response = await getProjectForm(idProject)
      if (response.Success) {
        const [data] = response.Data

        formik.setValues(
          {
            ...formik.values,
            IdProject: idProject,
            MiPymeCountry: data.MiPymeCountry,
            IdCountryCredit: data.IdCountry,
            IdLegalRepresentative: data.IdLegalRepresentative,
            LegalRepresentativeName: data.LegalRepresentativeName,
            Sector: data.Sector,
            MiPymeType: data.MiPymeType,
            TotalEmployees: data.TotalEmployees,
            IdIFI: data.IdIFI,
            RequiredAmount: data.RequiredAmount,
            BusinessName: data.BusinessName,
          },
          false,
        )
        setInfoProject(data)
        setPreEligibilityForm2(data)

        await getListCurrencyByCountry(data.IdCountry)
      } else {
        throw Error(
          'Error obteniendo informacion de Proyecto: ' + response.Message,
        )
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  const selectProject2 = async (idProject) => {
    try {
      const response = await getProjectForm(idProject)
      if (response.Success) {
        const [data] = response.Data
        formik.setValues(
          {
            ...formik.values,
            MiPymeCountry: data.MiPymeCountry,
            LegalRepresentativeName: data.LegalRepresentativeName,
            Sector: data.Sector,
            MiPymeType: data.MiPymeType,
            TotalEmployees: data.TotalEmployees,
            RequiredAmount: data.RequiredAmount,
            BusinessName: data.BusinessName,
          },
          false,
        )
        await getListCurrencyByCountry(data.IdCountry)
        setInfoProject(data)
        if (data.IdCurrency !== 3) {
          formik.setFieldValue(
            'RequiredAmountSourceCurrency',
            data.RequiredAmountSourceCurrency,
          )
        }
        setPreEligibilityForm2(data)
      } else {
        throw Error(
          'Error obteniendo informacion de Proyecto: ' + response.Message,
        )
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  const fillModalOptions = (ListMiPyme) => {
    if (ListMiPyme && ListMiPyme.length > 0) {
      const array = []
      let struct
      for (let i = 0; i < ListMiPyme.length; i++) {
        struct = {
          value: ListMiPyme[i].IdMiPyme,
          label: ListMiPyme[i].BusinessName,
        }

        array.push(struct)
      }
      if (array.length > 0) {
        setOptions(array)
      } else {
        setOptions([])
      }
    } else {
      setOptions([])
    }
  }

  return (
    <>
      {!secLoading ? (
        <div>
          <Grid
            container
            md={12}
            sm={12}
            spacing={1}
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <Grid item>
              <div
                data-tip
                data-for="exitPop"
                onClick={() => cancelForm()}
                style={{
                  backgroundColor: 'red',
                  color: '#fff',
                  width: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '4px',
                  padding: '5px',
                  cursor: 'pointer',
                }}
              >
                <ExitIcon style={{ transform: 'scaleX(-1)' }} />
                <ReactTooltip id="exitPop" effect="solid" backgroundColor="red">
                  <span>Regresar</span>
                </ReactTooltip>
              </div>
            </Grid>
            <Grid item>
              <div
                onClick={() => !loadingSave && saveForm(formik.values, true)}
                data-tip
                data-for="savePop"
                style={{
                  backgroundColor: !loadingSave ? '#5cb85c' : 'gray',
                  color: '#fff',
                  width: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '4px',
                  padding: '5px',
                  cursor: 'pointer',
                }}
              >
                <SaveIcon />
              </div>
              <ReactTooltip
                id="savePop"
                effect="solid"
                backgroundColor="#5cb85c"
              >
                <span>Guardar Borrador</span>
              </ReactTooltip>
            </Grid>
          </Grid>

          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box className="modalPYME">
              <div className="pymeDiv">
                <h1 className="pymeTitle">Seleccione una MIPYME</h1>
                <p className="pymeDescription">
                  Es necesario seleccionar una MIPYME para registrar un
                  formulario
                </p>
              </div>
              {/** cambiar la condicion a > 1 */}
              {IFIsMiPymeList.length > 1 ? (
                <Grid
                  container
                  spacing={1}
                  className="input__container selectPYME"
                >
                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl style={{ width: '100%' }}>
                      <SelectReact
                        classNamePrefix="select"
                        options={options}
                        placeholder="Seleccionar MIPYME"
                        onChange={(e) => {
                          setSelectedPYME(e)
                        }}
                        isClearable={true}
                        isSearchable={true}
                        defaultValue={selectedPYME}
                      />
                    </FormControl>
                    {pymeError !== '' ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '4px',
                          fontSize: '13px',
                        }}
                      >
                        {pymeError}
                      </div>
                    ) : null}
                  </Grid>
                  <Grid className="buttonsPYME">
                    <Button
                      className="cancelButton"
                      onClick={() => handleClose()}
                    >
                      Cancelar
                    </Button>
                    <Button
                      className="confirmButton"
                      onClick={() => handlePYME()}
                    >
                      Seleccionar
                    </Button>
                  </Grid>
                </Grid>
              ) : null}
            </Box>
          </Modal>
          <br></br>

          <form id="transfers-form" onSubmit={formik.handleSubmit}>
            <Grid item xs={12} sm={12} md={12}>
              <h1 className="h1text">INFORMACIÓN GENERAL</h1>
              <br />
            </Grid>

            <Grid container spacing={1}>
              <Grid container spacing={1} className="input__container">
                <Grid item xs={6} sm={6} md={6}>
                  <label className="responsiveLabel">
                    1.1. Nombre de la MIPYME
                  </label>
                  <a
                    data-tip="- Seleccione la entidad MIPYME deseada para la creación <br/> del formulario (Siempre que haya más de una MIPYME creada con estado PRE-ELEGIBLE)"
                    data-for="infoPymesPop"
                    style={{ cursor: 'pointer' }}
                  >
                    <ErrorOutlineIcon fontSize="small" />
                    <ReactTooltip
                      id="infoPymesPop"
                      effect="solid"
                      multiline={true}
                      type="dark"
                    />
                  </a>
                </Grid>

                <Grid item xs={6} sm={6} md={6}>
                  <label className="responsiveLabel">
                    1.1.2 Seleccione el proyecto
                  </label>
                  <a
                    data-tip="- Seleccione proyecto de MIPYME para la creación <br/> del formulario (Siempre que haya mas de un proyecto con estado PRE-ELEGIBLE)"
                    data-for="infoPymesPop"
                    style={{ cursor: 'pointer' }}
                  >
                    <ErrorOutlineIcon fontSize="small" />
                    <ReactTooltip
                      id="infoPymesPop"
                      effect="solid"
                      multiline={true}
                      type="dark"
                    />
                  </a>
                </Grid>
                {IFIsMiPymeList.length > 1 ? (
                  <Grid item xs={6} sm={6} md={6}>
                    <FormControl style={{ width: '100%' }}>
                      <div className="pymeSelect">
                        <TextField
                          id="MiPymeName"
                          name="MiPymeName"
                          style={{ width: '100%' }}
                          error={!!formik.errors.MiPymeName}
                          variant="outlined"
                          disabled
                          value={formik.values.MiPymeName || ''}
                        />
                        <a
                          data-tip="Seleccione una MIPYME para continuar con el registro de un formulario"
                          data-for="infoPYMEPop"
                          style={{ cursor: 'pointer' }}
                        >
                          <ReactTooltip
                            id="infoPYMEPop"
                            multiline={true}
                            type="dark"
                            disable={
                              IFIsMiPymeList && IFIsMiPymeList.length === 1
                            }
                          />
                        </a>
                      </div>

                      {formik.errors.MiPymeName ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.MiPymeName}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                ) : (
                  <Grid item xs={6} sm={6} md={6}>
                    <FormControl style={{ width: '100%' }}>
                      <TextField
                        id="MiPymeName"
                        style={{ width: '100%' }}
                        error={!!formik.errors.MiPymeName}
                        variant="outlined"
                        disabled
                        value={formik.values.MiPymeName || ''}
                      />
                    </FormControl>
                  </Grid>
                )}

                {/** proyecto select */}
                <Grid item xs={6} sm={6} md={6}>
                  <FormControl fullWidth>
                    <TextField
                      id="MiPymeName"
                      style={{ width: '100%' }}
                      error={!!formik.errors.MiPymeName}
                      variant="outlined"
                      disabled
                      value={formik.values.ProjectName}
                    />
                    {formik.errors.IdProject ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.IdProject}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    1.2. Período estimado de implementación de la inversión
                  </label>
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <FormControl style={{ width: '100%' }}>
                    <Stack noValidate spacing={3}>
                      <TextField
                        id="ImplementationDateStart"
                        label="Desde"
                        type="date"
                        name="ImplementationDateStart"
                        variant="outlined"
                        // defaultValue={formik.ImplementationDateStart}
                        sx={{ width: 220 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          min: '2021-06-30',
                          max: '2200-12-30',
                        }}
                        error={!!formik.errors.ImplementationDateStart}
                        value={formik.values.ImplementationDateStart || ''}
                        onChange={(e) => {
                          formik.handleChange(e)
                          if (e.target.value === '') {
                            formik.setValues({
                              ...formik.values,
                              ImplementationDateEnd: '',
                              ImplementationDateStart: '',
                            })
                          }
                        }}
                      />
                    </Stack>
                    {formik.errors.ImplementationDateStart ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.ImplementationDateStart}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                  <FormControl style={{ width: '100%' }}>
                    <Stack noValidate spacing={3}>
                      <TextField
                        id="ImplementationDateEnd"
                        name="ImplementationDateEnd"
                        label="Hasta"
                        type="date"
                        variant="outlined"
                        error={!!formik.errors.ImplementationDateEnd}
                        value={formik.values.ImplementationDateEnd || ''}
                        sx={{ width: 220 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          min: formik.values.ImplementationDateStart,
                        }}
                        disabled={formik.values.ImplementationDateStart === ''}
                        onChange={formik.handleChange}
                      />
                    </Stack>
                    {formik.errors.ImplementationDateEnd ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.ImplementationDateEnd}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    1.3. Fecha de presentación del formato de formulación del
                    subproyecto
                  </label>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <FormControl style={{ width: '100%' }}>
                    <Stack noValidate spacing={3}>
                      <TextField
                        id="PresentationDate"
                        name="PresentationDate"
                        type="date"
                        variant="outlined"
                        defaultValue={formik.values.PresentationDate}
                        sx={{ width: 220 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        className="multilineTextField"
                      />
                    </Stack>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    1.4. País donde se solicitará el crédito
                  </label>{' '}
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl fullWidth>
                    <Stack noValidate spacing={3}>
                      <TextField
                        id="MiPymeCountry"
                        name="MiPymeCountry"
                        type="text"
                        variant="outlined"
                        value={formik.values.MiPymeCountry || ''}
                        sx={{ width: 220 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        className="multilineTextField"
                      />
                    </Stack>
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    1.5. Institución Financiera
                  </label>{' '}
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl fullWidth>
                    <TextField
                      id="IdIFI"
                      name="IdIFI"
                      style={{ width: '100%' }}
                      value={formik.values.BusinessName || ''}
                      variant="outlined"
                      disabled
                      className="multilineTextField"
                    />
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    1.6. Presupuesto total del proyecto{' '}
                    <span style={{ color: 'red' }}>*</span>
                    <a
                      data-tip="Ingrese la moneda de préstamo"
                      data-for="infoCurrencyPop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="infoCurrencyPop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                  </label>
                </Grid>

                <Grid item xs={4} sm={4} md={4}>
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">Moneda</label>
                  </Grid>
                  <FormControl fullWidth>
                    <Select
                      id="IdCurrencyUser"
                      name="IdCurrencyUser"
                      error={!!formik.errors.IdCurrencyUser}
                      variant="outlined"
                      onChange={SelectCurrencyUser}
                      value={formik.values.IdCurrencyUser || ''}
                      displayEmpty={true}
                      renderValue={
                        formik.values.IdCurrencyUser !== 0
                          ? undefined
                          : () => 'Seleccione una opción'
                      }
                    >
                      <MenuItem disabled value={''}>
                        Seleccione una opción
                      </MenuItem>
                      {currencyType &&
                        currencyType.map((item) => (
                          <MenuItem
                            key={item.IdCurrency}
                            value={item.IdCurrency}
                          >
                            {item.Description}
                          </MenuItem>
                        ))}
                    </Select>
                    {formik.errors.IdCurrencyUser ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.IdCurrencyUser}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>

                <Grid item xs={4} sm={4} md={4}>
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      {formik.values.IdCurrencyUser
                        ? formik.values.IdCurrencyUser === 3
                          ? 'Monto moneda USD'
                          : 'Monto moneda local'
                        : 'Monto moneda local'}
                    </label>
                  </Grid>
                  <FormControl style={{ width: '100%' }}>
                    <NumberFormat
                      id="TotalSubProjectBudget"
                      name="TotalSubProjectBudget"
                      customInput={TextField}
                      displayType={'input'}
                      thousandSeparator={true}
                      isNumericString={true}
                      disabled={formik.values.IdCurrencyUser === 0}
                      value={formik.values.TotalSubProjectBudget}
                      decimalScale={2}
                      onBlur={(e) => {
                        const valueUnformatted = Number(
                          e.target.value.replaceAll(',', ''),
                        )
                        formik.setFieldValue(
                          'TotalSubProjectBudget',
                          Number(valueUnformatted),
                        )
                      }}
                      autoComplete="off"
                      error={!!formik.errors.TotalSubProjectBudget}
                      variant="outlined"
                      inputProps={{ maxLength: 18 }}
                      allowLeadingZeros={false}
                      fixedDecimalScale
                    />
                    {formik.errors.TotalSubProjectBudget ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.TotalSubProjectBudget}
                      </div>
                    ) : null}
                    {formik.errors.TotalSubProjectBudgetDollar ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.TotalSubProjectBudgetDollar}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>

                {showExchange ? (
                  <Grid item xs={4} sm={4} md={4}>
                    {loadingExchange ? (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        style={{ marginTop: '8%' }}
                      >
                        <LinearProgress />
                      </Grid>
                    ) : (
                      <Grid container>
                        <Grid item xs={12} sm={12} md={12}>
                          <label className="responsiveLabel">
                            Monto moneda USD
                          </label>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                          <FormControl style={{ width: '100%' }}>
                            <NumberFormat
                              id="TotalSubProjectBudgetDollar"
                              name="TotalSubProjectBudgetDollar"
                              customInput={TextField}
                              thousandSeparator={true}
                              value={formik.values.TotalSubProjectBudgetDollar}
                              autoComplete="off"
                              disabled
                              prefix="$"
                              allowNegative={false}
                              error={
                                !!formik.errors.TotalSubProjectBudgetDollar
                              }
                              variant="outlined"
                              isNumericString={true}
                              inputProps={{ maxLength: 12 }}
                              className="multilineTextField"
                            />
                          </FormControl>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                ) : (
                  ''
                )}
              </Grid>

              <Grid container spacing={1} className="input__container">
                <Grid item xs={4} sm={4} md={4}>
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      1.7. Monto del préstamo solicitado USD
                    </label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl style={{ width: '100%' }}>
                      <NumberFormat
                        id="RequiredAmount"
                        name="RequiredAmount"
                        customInput={TextField}
                        thousandSeparator={true}
                        value={infoProject.RequiredAmount}
                        autoComplete="off"
                        disabled
                        prefix="$"
                        allowNegative={false}
                        variant="outlined"
                        isNumericString={true}
                        inputProps={{ maxLength: 13 }}
                        fixedDecimalScale
                        decimalScale={2}
                        className="multilineTextField"
                      />
                    </FormControl>
                  </Grid>
                </Grid>
                {formik.values.IdCurrencyUser !== 3 &&
                  formik.values.IdCurrencyUser !== 0 && (
                    <Grid
                      item
                      xs={4}
                      sm={4}
                      md={4}
                      justifyContent="flex-end"
                      style={{
                        alignItems: 'flex-end',
                        justifyContent: 'flex-end',
                      }}
                    >
                      <Grid item xs={12} sm={12} md={12}>
                        <label className="responsiveLabel">
                          Monto moneda local
                        </label>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        justifyContent="flex-end"
                        style={{
                          alignItems: 'flex-end',
                          justifyContent: 'flex-end',
                          position: 'relative',
                        }}
                      >
                        <FormControl style={{ width: '100%' }}>
                          <NumberFormat
                            id="TotalSubProjectBudgetDollar"
                            name="TotalSubProjectBudgetDollar"
                            customInput={TextField}
                            thousandSeparator={true}
                            value={formik.values.RequiredAmountSourceCurrency}
                            autoComplete="off"
                            disabled
                            allowNegative={false}
                            variant="outlined"
                            isNumericString={true}
                            inputProps={{ maxLength: 12 }}
                            className="multilineTextField"
                            fixedDecimalScale
                            decimalScale={2}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  )}
              </Grid>

              <Grid container spacing={1} className="general_button">
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ textAlign: 'right' }}
                >
                  {/* <Button
                    type="button"
                    onClick={() => {
                      validateFormStatus()
                    }}
                    className="button__wizard button__next"
                    disabled={false}
                  >
                    {loading ? (
                      <CircularProgress size={23} color="white" />
                    ) : (
                      'Siguiente'
                    )}
                  </Button> */}
                  <LoadingButton
                    loading={loadingSave}
                    type="button"
                    onClick={() => validateFormStatus()}
                    className="button__wizard button__next"
                    variant="outlined"
                  >
                    Siguiente
                  </LoadingButton>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </div>
      ) : (
        <Box className="loadingEditContainer">
          <Grid className="loadingSub">
            <CircularProgress />
          </Grid>
        </Box>
      )}
    </>
  )
}

export default ElegibilidadEdit1
